import { apiInvoker } from '../../lib/apiInvoker';
import { API_URLS } from '../../lib/apiUrls';
import {
  fetchTopicsStart,
  fetchTopicsSuccess,
  fetchTopicsFailure,
} from '../slices/topicsSlice';
import { handleApiError } from '../../utils/errorHandler';

// Cache duration: 5 minutes
const CACHE_DURATION = 5 * 60 * 1000;

export const fetchTopics = (forceRefresh = false) => {
  return async (dispatch, getState) => {
    const { topics: topicsState } = getState();

    // Check if we have cached data that's still valid
    if (!forceRefresh && topicsState.lastFetched) {
      const timeSinceLastFetch = Date.now() - topicsState.lastFetched;
      if (timeSinceLastFetch < CACHE_DURATION && topicsState.scripts.length > 0) {
        // Use cached data, skip API call
        return;
      }
    }

    try {
      dispatch(fetchTopicsStart());
      const url = API_URLS.USER.GET_TOPICS;
      const response = await apiInvoker.get(url);
      
      if (response?.success && response?.data) {
        const topicsData = response.data.topics || [];
        const scriptsData = response.data.scripts || [];
        dispatch(fetchTopicsSuccess({ topics: topicsData, scripts: scriptsData }));
      } else if (response && !response.success) {
        throw new Error(response?.message || 'Failed to fetch topics');
      } else if (response) {
        const topics = Array.isArray(response) ? response : (response?.topics || []);
        const scripts = response?.scripts || [];
        dispatch(fetchTopicsSuccess({ topics, scripts }));
      } else {
        throw new Error('Invalid response from server');
      }
    } catch (error) {
      console.error('Topics fetch error:', error);
      
      const { message: errorMessage } = handleApiError(error, {
        defaultMessage: 'Failed to fetch topics',
        skipToastForStatus: [401, 403],
      });
      
      dispatch(fetchTopicsFailure(errorMessage));
    }
  };
};

